var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-img',{attrs:{"src":require("@/assets/images/contact/banner.jpg"),"fluid":"","alt":"wipe clear explore more"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }